import { z } from "zod";
import { id } from "./common";

export const apiKeyScope = z.enum(["leads:write", "availability:read"]);
export const apiKeyRecord = z.object({
  name: z.string().trim().min(1).max(120),
  defaultVenueId: id.nullable().optional(),
  defaultSourceId: id.nullable().optional(),
  scopes: z.array(apiKeyScope).min(1),
});
export const apiKeyCreate = apiKeyRecord.extend({ scopes: apiKeyRecord.shape.scopes.default(["leads:write"]) });
export type ApiKeyCreate = z.infer<typeof apiKeyCreate>;
